module.exports = __webpack_public_path__ + "fonts/Darwin-BlackItalic.be298f1.woff2";